<script setup lang="ts">
import RIcon from '../../base/RIcon/RIcon.vue'
import ContextMenuView from '../../base/menu/ContextMenuView.vue'
import { computed, onMounted, ref, type Ref, watch } from 'vue'
import type ContextMenuItem from '../../../type/ContextMenuItem'
import { useRouter } from 'vue-router'
import { currentUser, fetchUserProfile, currentUserHandle, DEMO_ID } from '@/composables/user/users'
import { isEmpty } from '@/utils/util'
import defaultImage from '@/assets/default_avatar.jpg'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const { t } = useI18n()

const contextMenuGroup: Ref<Array<Array<ContextMenuItem>>> = ref([
  [
    { name: t('menu.details'), key: 'details', icon: 'i-iconamoon:profile' } as ContextMenuItem,
    { name: t('menu.membership'), key: 'membership', icon: 'i-icon-park-outline:vip-one' } as ContextMenuItem
  ],
  [{ name: t('menu.logout'), key: 'logout', icon: 'i-clarity:logout-line', important: true } as ContextMenuItem]
])

const emit = defineEmits(['onAction'])

function onItemClicked(item: ContextMenuItem) {
  console.log('item clicked: ', item)
  emit('onAction', item.key)
}

const defaultName = t('action.click_to_refresh')

// onMounted(() => {
//   // 初始化 userProfile
//   fetchUserProfile()
// })

function toMe() {
  // if (displayName.value === defaultName) {
  //   fetchUserProfile()
  //   return
  // }
  router.push('/me')
  emit('onAction', 'me')
}

const avatarUrl = computed(() => {
  if (currentUser.value?.user?.avatar?.url) {
    return currentUser.value.user.avatar.url
  } else if (currentUser.value?.user?.wechatUserInfo?.wechatAvatar) {
    return currentUser.value.user.wechatUserInfo.wechatAvatar
  }
  return ''
})

const displayName = computed(() => {
  if (currentUser.value?.user?.name) {
    return currentUser.value.user?.name?.fullName
  } else if (currentUser.value?.user?.nickname) {
    return currentUser.value.user.nickname
  } else if (currentUser.value?.user?.wechatUserInfo) {
    return currentUser.value.user.wechatUserInfo?.nickname
  } else if (currentUserHandle.value == DEMO_ID) {
    return t('action.login_or_reigster')
  } else {
    return t('me.please_set_realname')
  }
  return defaultName
})

const memberState = computed(() => {
  return currentUser.value?.member?.state
})
</script>
<template>
  <div flex flex-row cursor-pointer items-center justify-between px-8 py-4 bg-sidebar @click.stop="toMe" z-3 menu-item>
    <UserAvatar
      :avatar="currentUser?.user?.avatar"
      :wechatInfo="currentUser?.user?.wechatUserInfo"
      rounded
      :size="6"
      mr-4 />
    <div flex="~ col" grow>
      <div
        truncate
        text-left
        text-base
        font-bold
        flex="~ row"
        items-baseline
        max-w-33
        line-clamp-1
        :class="memberState === 1 ? 'text-vip' : ''">
        {{ displayName }}
      </div>
      <div text-2.5 w-fit :class="memberState === 2 ? 'text-main' : 'text-second'" v-if="currentUserHandle !== DEMO_ID">
        {{
          memberState === 0
            ? $t('me.not_member')
            : memberState === 1
              ? $t('me.already_member')
              : $t('me.member_expired_full')
        }}
      </div>
    </div>
    <ContextMenuView :menuGroups="contextMenuGroup" @onItemClicked="onItemClicked">
      <template #trigger>
        <RIcon icon="i-iconamoon:menu-kebab-horizontal" :size="'small'" min-w-8 @click.stop=""></RIcon>
      </template>
    </ContextMenuView>
  </div>
</template>
<style lang="scss" scoped>
.context-menu {
  .el-popper {
    padding-left: 0px;
    padding-right: 0px;
  }
  background-color: red;
}
</style>
